// extracted by mini-css-extract-plugin
module.exports = {"resultModal":"__0zNoXP9t","resIcon":"aUYt7cbG","title":"m6ZFwX1i","tip":"xHrduxen","list":"VNOqBM07","item":"UejgtH42","label":"F4Hxqzbi","value":"g0PbbhWp","divider":"L4QtwwD5"};